import Page, { EPageVariant } from 'ui/Page/Page';

import classes from './statis.module.scss';

export default function Oferta() {
  return (
    <Page variant={EPageVariant.WEB} header footer>
      <h3>Пользовательское соглашение</h3>

      <p>
      Последнее обновление: 10 июня 2026 года.
      </p>

      <h4>I. Общие положения</h4>

      <p>
      Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует порядок использования веб-сайта
      <a href='https://flearn.net'> flearn.net</a> (далее — «Сайт»).
      </p>

      <ol>
          <li>
              Владельцем и правообладателем Сайта является Ulianova Sofiia (далее — «Правообладатель»).
          </li>
          <li>
              Сайт представляет собой некоммерческий информационный ресурс, предназначенный для публикации материалов, взаимодействия пользователей и использования функциональности Сайта.
          </li>
          <li>
              Использование Сайта означает полное и безоговорочное согласие пользователя с условиями настоящего Соглашения.
          </li>
          <li>
              Если пользователь не согласен с условиями Соглашения, он обязан прекратить использование Сайта.
          </li>
          <li>
              Настоящее Соглашение применяется ко всем пользователям Сайта независимо от страны их проживания или гражданства.
          </li>
      </ol>

      <h4>II. Назначение Сайта</h4>

      <ol>
          <li>
              Сайт предоставляет пользователям возможность получать доступ к размещенным материалам, создавать учетные записи и использовать доступную функциональность.
          </li>
          <li>
              Пользователи могут публиковать собственный контент в пределах возможностей, предусмотренных Сайтом.
          </li>
          <li>
              Сайт не осуществляет продажу товаров, работ или услуг и не принимает платежи от пользователей.
          </li>
          <li>
              Информация, размещенная на Сайте, предоставляется исключительно в информационных целях.
          </li>
      </ol>

      <h4>III. География использования</h4>

      <ol>
          <li>
              Сайт предназначен преимущественно для русскоязычных пользователей, проживающих за пределами Российской Федерации.
          </li>
          <li>
              Использование русского языка на Сайте осуществляется исключительно в целях удобства пользователей.
          </li>
          <li>
              К отношениям между пользователями и Правообладателем применяется законодательство Республики Сербия.
          </li>
      </ol>

      <h4>IV. Регистрация и учетная запись</h4>

      <ol>
          <li>
              Для доступа к отдельным функциям Сайта пользователю может потребоваться создание учетной записи.
          </li>
          <li>
              Регистрация может осуществляться посредством авторизации через сервис Google.
          </li>
          <li>
              Пользователь обязуется предоставлять достоверную информацию о себе.
          </li>
          <li>
              Пользователь несет ответственность за действия, совершенные через его учетную запись.
          </li>
          <li>
              Правообладатель не получает и не хранит пароль пользователя от учетной записи Google.
          </li>
      </ol>

      <h4>V. Пользовательский контент</h4>

      <ol>
          <li>
              Пользователь вправе публиковать материалы, комментарии, сообщения и иной контент через функциональность Сайта.
          </li>
          <li>
              Пользователь гарантирует наличие необходимых прав на публикуемый контент.
          </li>
          <li>
              Пользователь несет самостоятельную ответственность за содержание размещаемых материалов.
          </li>
          <li>
              Пользователь не вправе размещать контент, который:
              <ul>
                  <li>нарушает законодательство;</li>
                  <li>нарушает права третьих лиц;</li>
                  <li>содержит угрозы, оскорбления или дискриминацию;</li>
                  <li>содержит вредоносное программное обеспечение;</li>
                  <li>нарушает права интеллектуальной собственности.</li>
              </ul>
          </li>
          <li>
              Размещая контент на Сайте, пользователь предоставляет Правообладателю неисключительное право на хранение, отображение и техническую обработку такого контента в целях функционирования Сайта.
          </li>
      </ol>
      <h4>VI. Права и обязанности пользователя</h4>
      <ol>
          <li>
              Пользователь вправе использовать Сайт в соответствии с настоящим Соглашением.
          </li>
          <li>
              Пользователь вправе просматривать материалы Сайта, создавать учетную запись и использовать доступную функциональность.
          </li>
          <li>
              Пользователь вправе обратиться к Правообладателю по вопросам работы Сайта по адресу электронной почты: ulianova.sofia@gmail.com.
          </li>
          <li>
              Пользователь обязуется использовать Сайт добросовестно и не нарушать права Правообладателя, других пользователей и третьих лиц.
          </li>
          <li>
              Пользователь обязуется не предпринимать действий, которые могут нарушить работу Сайта, его программного обеспечения, серверов или сетевой инфраструктуры.
          </li>
          <li>
              Пользователь обязуется не использовать Сайт для рассылки спама, размещения вредоносного кода, автоматического сбора данных или иных недобросовестных действий.
          </li>
      </ol>

      <h4>VII. Права Правообладателя</h4>

      <ol>
          <li>
              Правообладатель вправе самостоятельно определять структуру, внешний вид, содержание и функциональность Сайта.
          </li>
          <li>
              Правообладатель вправе изменять, дополнять или удалять материалы и функции Сайта.
          </li>
          <li>
              Правообладатель вправе временно ограничивать доступ к Сайту для проведения технических работ.
          </li>
          <li>
              Правообладатель вправе удалить или ограничить доступ к пользовательскому контенту, если такой контент нарушает настоящее Соглашение, права третьих лиц или применимое законодательство.
          </li>
          <li>
              Правообладатель вправе ограничить доступ пользователя к Сайту или удалить учетную запись пользователя в случае нарушения настоящего Соглашения.
          </li>
      </ol>

      <h4>VIII. Интеллектуальная собственность</h4>

      <ol>
          <li>
              Все права на Сайт, включая программный код, дизайн, структуру, тексты, изображения, графические элементы и иные материалы, принадлежат Правообладателю либо используются Правообладателем на законных основаниях.
          </li>
          <li>
              Пользователь не вправе копировать, изменять, распространять, публиковать или использовать материалы Сайта без предварительного согласия Правообладателя, за исключением случаев, прямо предусмотренных законодательством.
          </li>
          <li>
              Использование Сайта не означает передачу пользователю каких-либо исключительных прав на Сайт или его материалы.
          </li>
          <li>
              Пользователь сохраняет права на контент, который он самостоятельно размещает на Сайте.
          </li>
      </ol>

      <h4>IX. Ограничение ответственности</h4>

      <ol>
          <li>
              Сайт предоставляется пользователям по принципу «как есть».
          </li>
          <li>
              Правообладатель не гарантирует бесперебойную, безошибочную или полностью безопасную работу Сайта.
          </li>
          <li>
              Правообладатель не несет ответственности за невозможность использования Сайта, технические сбои, потерю данных или иные последствия, вызванные действиями третьих лиц, работой провайдеров, хостинг-сервисов, сервисов Google или иных внешних сервисов.
          </li>
          <li>
              Правообладатель не несет ответственности за пользовательский контент, размещенный другими пользователями.
          </li>
          <li>
              Пользователь самостоятельно оценивает достоверность и применимость информации, размещенной на Сайте.
          </li>
      </ol>

      <h4>X. Блокировка и удаление учетной записи</h4>

      <ol>
          <li>
              Пользователь вправе запросить удаление своей учетной записи, направив обращение на адрес электронной почты: ulianova.sofia@gmail.com.
          </li>
          <li>
              Правообладатель вправе удалить учетную запись пользователя или ограничить доступ к ней в случае нарушения пользователем настоящего Соглашения.
          </li>
          <li>
              После удаления учетной записи часть технических данных может временно сохраняться в резервных копиях или журналах безопасности, если это необходимо для защиты Сайта или выполнения требований применимого законодательства.
          </li>
      </ol>

      <h4>XI. Персональные данные</h4>

      <ol>
          <li>
              Обработка персональных данных пользователей осуществляется в соответствии с Политикой конфиденциальности, размещенной по адресу:
              <a href='https://flearn.net/policy'>https://flearn.net/policy</a>.
          </li>
          <li>
              Используя Сайт, пользователь подтверждает ознакомление с Политикой конфиденциальности.
          </li>
      </ol>

      <h4>XII. Изменение Соглашения</h4>

      <ol>
          <li>
              Правообладатель вправе в любое время изменять настоящее Соглашение.
          </li>
          <li>
              Новая редакция Соглашения вступает в силу с момента ее публикации на Сайте.
          </li>
          <li>
              Продолжение использования Сайта после публикации новой редакции Соглашения означает согласие пользователя с внесенными изменениями.
          </li>
      </ol>

      <h4>XIII. Применимое право и разрешение споров</h4>

      <ol>
          <li>
              Настоящее Соглашение регулируется законодательством Республики Сербия.
          </li>
          <li>
              Все споры и разногласия, связанные с использованием Сайта, стороны по возможности разрешают путем переговоров.
          </li>
          <li>
              Если спор не может быть урегулирован путем переговоров, он подлежит рассмотрению в соответствии с законодательством Республики Сербия.
          </li>
      </ol>

      <h4>XIV. Контактная информация</h4>

      <ol>
          <li>
              По вопросам, связанным с использованием Сайта, пользователь может обратиться к Правообладателю по адресу электронной почты: ulianova.sofia@gmail.com.
          </li>
          <li>
              Правообладатель:
              <br />
              <strong>Ulianova Sofiia</strong>
              <br />
              Республика Сербия
              <br />
              E-mail: ulianova.sofia@gmail.com
          </li>
      </ol>

      <h4>XV. Заключительные положения</h4>

      <ol>
          <li>
              Если какое-либо положение настоящего Соглашения будет признано недействительным, это не влияет на действительность остальных положений.
          </li>
          <li>
              Актуальная версия Соглашения размещается по адресу:
              <a href='https://flearn.net/oferta'> flearn.net/oferta</a>.
          </li>
      </ol>
    </Page>
  );
}
